import React from "react";
import Button from "../Button";
import { Transforms } from "slate";
import { useSlate } from "slate-react";
import { ELEMENT_DIVIDER, EMPTY_CHILDREN, getNewParagraph } from "../../Element";
import Icon, { ICON_INSERT_DIVIDER } from "../Icon";

export default function InsertDividerButton() {
  const editor = useSlate();

  return (
    <Button
      onMouseDown={(event) => {
        event.preventDefault();
        // check for left click
        if (event.button === 0) {
          const divider = [
            {
              type: ELEMENT_DIVIDER,
              ...EMPTY_CHILDREN,
            },
            getNewParagraph(),
          ];

          Transforms.insertNodes(editor, divider);
        }
      }}
    >
      <Icon iconName={ICON_INSERT_DIVIDER} />
    </Button>
  );
}
